<template>
  <v-row>
    <v-col>
      <v-card :elevation="styleOptions.elevation" outlined>
        <v-card-title class="text-right" v-if="title">{{ title }}
          <v-spacer></v-spacer>
          <slot name="action-icon"></slot>
        </v-card-title>
        <v-card-subtitle v-if="subtitle">{{ subtitle }}</v-card-subtitle>
        <v-card-text>
          <slot></slot>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { defaultStyles } from '../../services/Defaults'

export default {
  name: 'MaocCard',
  props: {
    title: String,
    subtitle: String
  },
  data: vm => ({
    styleOptions: defaultStyles
  })
}
</script>
